import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11.938 10.282c.62.434.803.947.67 1.721-.11.629-.392 1.048-.89 1.321-1.273.706-3.898.427-6.684-.703a1.15 1.15 0 0 0-1.499.627 1.14 1.14 0 0 0 .63 1.489C5.306 15.199 7.604 16 9.83 16c1.064 0 2.113-.184 3.009-.677 1.107-.61 1.812-1.623 2.038-2.932.144-.831.078-1.52-.125-2.109zm5.6-2.857-6.344-.001c-.57-.2-1.143-.37-1.678-.522-3.071-.88-3.985-1.395-3.726-2.904.09-.52.365-.927.816-1.216.736-.47 2.302-.85 5.585.013a1.15 1.15 0 0 0 1.406-.812 1.14 1.14 0 0 0-.818-1.397C9.498-.278 7.004-.186 5.365.859a4.06 4.06 0 0 0-1.84 2.752c-.317 1.836.353 3.007 1.406 3.814H.863C.385 7.425 0 7.81 0 8.25c0 .473.386.825.863.825h16.675c.476 0 .862-.384.862-.825s-.384-.825-.862-.825" }, null, -1)
  ])))
}
export default { render: render }